<app-breadcrumb [title]="'Users'"></app-breadcrumb>
<div class="container-fluid">
  <div class="row">
    <div class="col">
      <div class="card">
        <div class="card-body">
          <div class="row g-3">
            <div class="col-3">
              <label class="visually-hidden" for="username">Email</label>
              <input type="text" placeholder="Email" class="form-control mb-2 mr-sm-2" [(ngModel)]="query.username"
                #username="ngModel" />
            </div>
            <div class="col-3">
              <label class="visually-hidden" for="shalaId">Shala ID</label>
              <input type="text" placeholder="Shala ID" class="form-control mb-2 mr-sm-2" [(ngModel)]="query.shalaId"
                #shalaId="ngModel" />
            </div>
            <div class="col">
              <button type="button" class="btn btn-success mb-2" (click)="filter()">
                Search
              </button>
            </div>
          </div>
        </div>

        <div class="card-body">
          <div *ngIf="queryResult.items" class="table-responsive">
            <table class="table table-hover align-middle">
              <colgroup>
                <col style="width: 20%">
                <col style="width: 20%">
                <col style="width: 20%">
                <col style="width: 20%">
              </colgroup>
              <thead class="table-light">
                <tr>
                  <th class="text-uppercase" *ngFor="let c of columns">
                    <div *ngIf="c.isSortable" (click)="sortBy(c.key)">
                      <div class="d-flex justify-content-between align-items-center">
                        {{ c.title }}
                        <div class="ml-2">
                          <i-bs *ngIf="query.sort === c.key"
                            [name]="query.sortDir == 'Ascending' ? 'arrow-up' : 'arrow-down'" width="1em" height="1em">
                          </i-bs>
                        </div>
                      </div>
                    </div>
                    <div *ngIf="!c.isSortable">
                      {{ c.title }}
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let v of queryResult.items">
                  <td class="align-middle">{{ v.email }}</td>
                  <td class="align-middle">{{ v.createdAt | date }}</td>
                  <td class="align-middle">
                    <span *ngIf="v.isEnabled" class="badge bg-success text-white">Active</span>
                    <span *ngIf="!v.isEnabled" class="badge badge-danger">Deactive</span>
                  </td>
                  <td>
                    <a class="btn btn-light btn-sm mr-2" [routerLink]="['/admin/users/edit-profile/', v.id]">Edit</a>
                    <a class="btn btn-light btn-sm" [routerLink]="['/admin/users/change-password/', v.id]">Change
                      Password</a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <pagination [total-rows]="queryResult.totalRows" [current-page]="query.page" [page-size]="query.pageSize">
          </pagination>
        </div>
      </div>
    </div>
  </div>
</div>
